import { Box, Stack } from '@mui/material'

import { OptimizationStrategy } from './OptimizationStrategy'
import { StrategyExamplePanel } from './StrategyExamplePanel'

export function Body() {
  return (
    <Stack direction="row">
      <Box flex="1 1 55%" minWidth={480} p={3}>
        <OptimizationStrategy />
      </Box>
      <Box
        flex="1 1 45%"
        minWidth={380}
        p={3}
        sx={{ backgroundColor: t => t.vars.palette.background.default3 }}
      >
        <StrategyExamplePanel />
      </Box>
    </Stack>
  )
}
